module.exports = __webpack_public_path__ + "static/media/warranty.a1974f2a.png";